import React from "react";

const GradientBackground = ({ children }) => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Gradient Background Layer */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle at 0% 20%, rgb(236, 72, 153) 0%, transparent 15%),
            radial-gradient(circle at 95% 0%, rgb(34, 211, 238) 0%, transparent 15%),
            linear-gradient(to left, hsl(var(--brand-light)), hsl(var(--brand-primary)))
          `,
        }}
      />
      {/* Content Layer */}
      <div className="relative min-h-screen">{children}</div>
    </div>
  );
};

export default GradientBackground;
